'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _Discussion = require('./Discussion');

var _Discussion2 = _interopRequireDefault(_Discussion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 */
var mapStateToProps = function mapStateToProps(state, _ref) {
	var chatId = _ref.chatId;
	var id = _ref.id;
	var _ref$reducer = _ref.reducer;
	var reducer = _ref$reducer === undefined ? 'vtChat' : _ref$reducer;

	var discussion = (0, _lodash.get)(state, [reducer, 'discussions', chatId, id], {});
	var user = (0, _lodash.get)(state, [reducer, 'user'], {});

	return _extends({}, discussion, {
		user: user
	});
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_Discussion2.default);